/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import {
  useState,
  useEffect,
  useContext,
  useCallback,
  useMemo,
  useRef,
} from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import cn from 'classnames';
import LockIcon from '@mui/icons-material/Lock';
import RightArrowImg, {
  ReactComponent as RightArrow,
} from 'Assets/category-right-arrow.svg';
import LeftArrowImg, {
  ReactComponent as LeftArrow,
} from 'Assets/category-left-arrow.svg';
import AlterImage from 'Assets/no-image-available.png';
import { dataFetcher, endpoints, axios, baseUrl } from 'Api';
import { ProfilePage, Button } from 'Components';
import { AuthContext, AppContext } from 'Context';
// eslint-disable-next-line
import { Swiper, SwiperSlide } from "swiper/react";
// eslint-disable-next-line
import "swiper/swiper-bundle.min.css"; // ✅ Import full Swiper styles
// eslint-disable-next-line
import SwiperCore, { Navigation, Pagination } from "swiper/core";
import { Pathname } from 'Routes';
import { Image } from 'semantic-ui-react';
import { Box } from '@mui/material';
import { CONTENT_TYPES } from 'Pages/private/profile';
import RowCarousel from 'Components/reactbits/RowCarousel';
// Row-heading glyphs disabled — no icon next to section titles.
// import { AnimatedCategory, AnimatedPlaylist, AnimatedAlbum } from 'Components/reactbits/AnimatedIcons';
import { getThumbnailTileStyle } from 'Config/featureFlags';
import VideoAutoPlayer from './video-autoplayer';
import styles from './index.module.css';
import { TitleLabel } from './video-autoplayer/TitleLabel';

SwiperCore.use([Navigation, Pagination]);
const isTrueValue = true;
const isFalseValue = false;
// Row-type glyphs shown before the section heading — the same icon set the
// nav wheel uses (category / playlist / album), rendered static (no animate).
// Disabled: section headings are text-only now (no icon next to the title).
// const ROW_TYPE_ICON = {
//   category: <AnimatedCategory size={18} strokeWidth={2.2} />,
//   playlist: <AnimatedPlaylist size={18} strokeWidth={2.2} />,
//   album: <AnimatedAlbum size={18} strokeWidth={2.2} />,
// };

const ImageGroupTitle = ({
  resumeMe,
  title,
  setResumeMe,
  marginTitle,
  resumeWatching,
  setLoading,
  clearResumeWatching,
  // iconType, // row-heading glyph disabled
}) => (
  <>
    {title && (
      <div className={styles.headingWrapper}>
        <h3
          className={cn({
            [styles.imageGroupTitle]: true,
            [styles.marginTitle]: !marginTitle,
          })}
        >
          {/* Row-heading glyph disabled — headings are text-only.
          {iconType && ROW_TYPE_ICON[iconType] && (
            <span className={styles.rowTypeIcon}>{ROW_TYPE_ICON[iconType]}</span>
          )} */}
          {title}
        </h3>
        {resumeMe?.content?.length > 0 ? (
          <div
            onClick={() => {
              // setLoading(true);

              clearResumeWatching();
              setResumeMe(null);
            }}
            className={styles.clearAll}
          >
            Clear All
          </div>
        ) : null}
      </div>
    )}
  </>
);

const CustomRightArrow = ({ onClick, align }) => (
  <RightArrow
    fontSize="large"
    onClick={onClick}
    aria-label="Go to next slide"
    className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right custom_arrow custom-next"
  // className="right-arrow"
  // style={{ marginTop: align && '5px' }}
  />
);

const CustomLeftArrow = ({ onClick }) => (
  <LeftArrow
    onClick={onClick}
    aria-label="Go to next slide"
    className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left custom_arrow custom-prev"
  // className="left-arrow"
  // style={{ zIndex: '1000', cursor: 'pointer', height: '40px', marginLeft: '-100%', background: 'none' }}
  />
);
const ViewMyProjector = ({
  pagination,
  albumPagination,
  offset,
  setVideoOffset,
  fetchData,
  imageData,
  isphoto,
  resumeMe,
  setResumeMe,
  responseData,
  profileDetails,
  title,
  isGrid,
  type,
  catG,
  resumeWatching,
  setLoading,
  clearResumeWatching,
  handleCarousel,
  onShowPermissionModal,
  hideVideoTitles,
  onVideoOpen,
  onAlbumHover,
  onAlbumLeave,
  onAlbumOpen,
}) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 2, // optional, default to 1.
    },
  };

  const responsiveImage = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1.5,
      slidesToSlide: 2, // optional, default to 1.
    },
  };
  const navigate = useNavigate();
  const urlParams = useParams();
  const { getToken } = useContext(AuthContext);

  const { loader, setLoader, setcategoryLoader, userDetails, subscriptionDetails } = useContext(AppContext);
  const profileID = urlParams?.profileID || userDetails.myId;
  const carouselRefs = useRef({});
  const [currentSlides, setCurrentSlides] = useState({});
  const [isMoving, setMoving] = useState(false);
  const [showArrow, setArrows] = useState(false);
  const [showAutoPlayDiv, setAutoPlayDiv] = useState(undefined);
  const loadingMore = useRef({}); // Track loading state per playlist/category to prevent duplicate calls
  const [loadingStates, setLoadingStates] = useState({}); // Track loading state for UI (shimmer)
  const swiperInstances = useRef({}); // Store swiper instances to control them after data loads
  const filteredPhotos = imageData?.data?.filter(
    (element) => element?.photos && element?.photos?.length > 0
  );
  let myTimeout;
  const [dimensions, setDimensions] = useState({
    // top: '0px',
    // left: '0px',
  });
  const [videoDetails, setVideoDetails] = useState({
    videoURL: '',
    thumbNail: '',
    title: '',
    subCategory: '',
  });
  const mouseOverHandler = (
    event,
    id,
    video_file,
    thumbnails,
    title,
    subCategory,
    video_raw_file
  ) => {
    const rect = event.target.getBoundingClientRect();
    setDimensions({});
    setAutoPlayDiv(id);
    setVideoDetails({
      videoURL: video_file || video_raw_file,
      thumbNail: thumbnails,
      title,
      subCategory,
    });
  };

  const mouseLeaveHandler = () => {
    clearInterval(myTimeout);
    setAutoPlayDiv(undefined);
    setVideoDetails({
      videoURL: '',
      thumbNail: '',
      title: '',
      subCategory: '',
    });
  };

  // Check video permission
  // TODO: TEMPORARY - All access enabled. Revert to original logic when needed.
  const hasVideoPermission = () => true;
  /* ORIGINAL hasVideoPermission LOGIC - Replace above line to restore:
  const hasVideoPermission = (videoId) => {
    try {
      // If user has upgraded plan (is_locked = 0), allow all videos
      const isLocked = subscriptionDetails?.subscription?.is_locked;
      if (isLocked === '0' || isLocked === 0) {
        return true;
      }

      // Otherwise, check if video is in allowed list
      const allowedVideoIds = JSON.parse(localStorage.getItem('allowedVideoIds') || '[]');
      return allowedVideoIds.includes(String(videoId));
    } catch (error) {
      return false;
    }
  };
  */

  // Check if video is locked for the current user's plan
  // locked_for contains comma-separated plan IDs (e.g., "14" or "14,15,16")
  const isVideoLockedForUser = (lockedFor) => {
    try {
      if (!lockedFor) return false;

      // Get the current user's plan ID
      const currentPlanId = subscriptionDetails?.subscription?.plan_id
        || subscriptionDetails?.plans?.[subscriptionDetails?.plans?.length - 1]?.plan_id;

      if (!currentPlanId) return false;

      // Parse locked_for (comma-separated string like "14,15,16")
      const lockedPlanIds = String(lockedFor).split(',').map((id) => id.trim());

      // Check if user's plan is in the locked list
      return lockedPlanIds.includes(String(currentPlanId));
    } catch (error) {
      return false;
    }
  };

  // Check album permission
  // TODO: TEMPORARY - All access enabled. Revert to original logic when needed.
  const hasAlbumPermission = () => true;
  /* ORIGINAL hasAlbumPermission LOGIC - Replace above line to restore:
  const hasAlbumPermission = (albumId) => {
    try {
      // If user has upgraded plan (is_locked = 0), allow all albums
      const isLocked = subscriptionDetails?.subscription?.is_locked;
      if (isLocked === '0' || isLocked === 0) {
        return true;
      }

      // Otherwise, check if album is in allowed list
      const allowedAlbumIds = JSON.parse(localStorage.getItem('allowedAlbumIds') || '[]');
      return allowedAlbumIds.includes(String(albumId));
    } catch (error) {
      return false;
    }
  };
  */

  useEffect(() => {
    const autoPlayElement = document?.getElementById('autoplay-div');
    const thumbnailLinkElement = document?.getElementById('thumbnail-link');
    autoPlayElement?.addEventListener('mouseleave', mouseLeaveHandler);
    return () => autoPlayElement?.removeEventListener('mouseleave', mouseLeaveHandler);
  });
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setLoader(false);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, []);
  const [swiperStates, setSwiperStates] = useState({}); // e.g., { [categoryId]: { atEnd: false, atBeginning: true } }

  function beforeChange(index, type, obj, swiper) {
    const key = obj?.category_id ?? obj?.playlist_id;
    const totalVideos = obj?.videos?.length || 0;
    const hasNextPage = obj?.videoPagination?.hasNextPage === true;

    // Calculate the last visible slide index based on slidesPerView
    const slidesPerView = swiper?.params?.slidesPerView || 4;
    const lastVisibleIndex = index + slidesPerView - 1;

    // Load more when the last visible slide is within 2 items of the end
    const shouldLoadMore = lastVisibleIndex >= totalVideos - 2;

    // console.log('🔍 beforeChange debug:', {
    //   type,
    //   key,
    //   index,
    //   slidesPerView,
    //   lastVisibleIndex,
    //   totalVideos,
    //   shouldLoadMore,
    //   hasNextPage,
    //   isLoading: loadingMore.current[key],
    //   videoPagination: obj?.videoPagination,
    // });

    if (shouldLoadMore && hasNextPage && !loadingMore.current[key]) {
      loadingMore.current[key] = true; // Mark as loading to prevent duplicate calls
      setLoadingStates((prev) => ({ ...prev, [key]: true })); // Show shimmer
      console.log('✅ Triggering fetch for playlist:', key);

      setVideoOffset((prevOffsets) => {
        const currentOffset = prevOffsets[key] ?? 0;
        const newOffset = currentOffset + 10;
        console.log('📤 Fetching with offset:', newOffset);

        // Fetch more videos for this specific playlist
        // First param (pageOffset) stays 0 - we're not loading more playlists
        // Second param is the playlist_id
        // Third param is the video offset within that playlist
        fetchData(0, key, newOffset)
          .then(() => {
            console.log('✅ Fetch completed for:', key);
            // Auto-slide to show new content after a brief delay for DOM update
            setTimeout(() => {
              if (swiperInstances.current[key]) {
                swiperInstances.current[key].slideNext();
              }
            }, 100);
          })
          .catch((err) => {
            console.error('❌ Fetch error:', err);
          })
          .finally(() => {
            loadingMore.current[key] = false; // Reset loading flag when done
            setLoadingStates((prev) => ({ ...prev, [key]: false })); // Hide shimmer
          });

        return {
          ...prevOffsets,
          [key]: newOffset,
        };
      });
    }
  }
  const currentOffset = useRef(10); // start at 10 since 0 is already loaded

  function albumUpdater(index, type, obj) {
    if (index >= 3 && albumPagination?.hasNextPage === true) {
      fetchData(currentOffset.current);
      currentOffset.current += 10; // increment after fetching
    }
  }
  useEffect(() => {
    if (Array.isArray(responseData)) {
      responseData?.forEach((obj) => {
        const categoryId = obj?.category_id;
        const lastSlide = currentSlides[categoryId] || 0;

        if (carouselRefs.current[categoryId]) {
          setTimeout(() => {
            carouselRefs.current[categoryId].goToSlide(lastSlide);
          }, 200);
        }
      });
    }
  }, [responseData]);
  const [loadedImages, setLoadedImages] = useState({});
  const [albumScrollState, setAlbumScrollState] = useState({
    atBeginning: true,
    atEnd: false,
  });

  const [albumHasScroll, setAlbumHasScroll] = useState(false);
  const currentWidth = window.innerWidth;
  const slidesPerView = currentWidth >= 640 ? 4 : 3;
  // Tile display style (see featureFlags + video-autoplayer). Every non-letterbox
  // style drives slide width from CSS, so the video-tile slides get a per-style
  // modifier class and the Resume Watching Swiper switches to 'auto' (read each
  // slide's own width) instead of a fixed slidesPerView count.
  const tileStyle = getThumbnailTileStyle();
  const customTiles = tileStyle !== 'letterbox';
  const rowSlideExtra = {
    adaptive: styles.rowVideoSlideAdaptive,
    poster: styles.rowVideoSlidePoster,
    framed: styles.rowVideoSlideFramed,
    // cinematic sizes like adaptive (rail), with the title overlaid on the tile.
    cinematic: styles.rowVideoSlideAdaptive,
  }[tileStyle];
  const swiperSlideExtra = {
    adaptive: styles.swiperSlideAdaptive,
    poster: styles.swiperSlidePoster,
    framed: styles.swiperSlideFramed,
    cinematic: styles.swiperSlideAdaptive,
  }[tileStyle];
  const swiperSlidesPerView = customTiles ? 'auto' : slidesPerView;
  // Resume Watching is still a Swiper while every other row is a RowCarousel,
  // and a RowCarousel reserves 44px on each side for its chevrons (40px button
  // + 4px margin). Without the same reservation this row's tiles sat ~44px left
  // of every other row's. Below 768px the chevrons are hidden, so there is
  // nothing to reserve. Matches .headingWrapper's own breakpoint.
  const resumeRowInset = currentWidth >= 768 ? 44 : 0;
  const hasScrollableSlides = responseData?.content?.length > slidesPerView;
  return (
    <div>
      {/* No loader of its own: while `loader` was true this swapped the whole
          projector for a full-width red ProgressBar, which showed up as a
          second loader right after the page's shimmer skeleton cleared. The
          skeleton in Pages/private/profile is the only load indicator now —
          rows render straight through and fill in as their data arrives. */}
      {(
        <div
          className={cn({
            [styles.paddingTop0]: true,
            [styles.imageGroup]: true,
            [styles.paddingTopForImage]: catG,
          })}
        >
          <div
            style={{ alignItems: 'baseline' }}
            className={cn(styles.headingWrapper, styles.headingWrapperFlush)}
          >
            {type === 'Resume Watching'
              && responseData?.content?.length > 0 && (
                <ImageGroupTitle
                  title="Resume watching"
                  marginTitle={catG}
                  resumeWatching={resumeWatching}
                  setLoading={setLoading}
                  clearResumeWatching={clearResumeWatching}
                />
              )}
            {type === 'Resume Watching' && responseData?.content?.length > 0 ? (
              <div
                onClick={() => {
                  alert('Are you sure you want to clear all resume watching?');
                  clearResumeWatching();
                  setResumeMe(null);
                }}
                className={styles.clearAll}
              >
                Clear All
              </div>
            ) : null}
          </div>
          {/* {searchTerm && <ImageGroupTitle title={`Search results for "${searchTerm}"`} />} */}
          <div>
            <div
              className={cn({
                [styles.imageGroupImagesContainer]: true,
                [styles.isGrid]: isGrid,
              })}
            >
              {/* resume watching */}
              {type === 'Resume Watching'
                && responseData?.content?.length > 0 && (
                  <ImageGroupTitle
                    setResumeMe={setResumeMe}
                    resumeMe={resumeMe}
                    title={resumeMe?.content_type}
                    marginTitle={catG}
                    resumeWatching={resumeWatching}
                    setLoading={setLoading}
                    clearResumeWatching={clearResumeWatching}
                  />
                )}
              <div
                onMouseEnter={() => setArrows(true)}
                onMouseLeave={() => setArrows(false)}
              >
                <Swiper
                  style={{
                    paddingLeft: `${resumeRowInset}px`,
                    paddingRight: `${resumeRowInset}px`,
                  }}
                  slidesPerView={swiperSlidesPerView}
                  spaceBetween={20}
                  breakpoints={customTiles ? undefined : {
                    0: {
                      slidesPerView: 2.2,
                      spaceBetween: 20,
                    },
                    640: {
                      slidesPerView: 4,
                      spaceBetween: 20,
                    },
                  }}
                  navigation={hasScrollableSlides} // ✅ conditionally enabled
                  // loop
                  slidesPerGroup={2}
                  pagination={false}
                  modules={[Navigation]}
                >
                  {type === 'Resume Watching'
                    && responseData?.content?.length > 0
                    && responseData?.content?.map((obj, idx) => (
                      <SwiperSlide key={idx} className={swiperSlideExtra || undefined}>
                        <div className={styles.imageGroupImagesWrapper}>
                          <Box
                            className={cn(styles.hoverZoom, {
                              [styles.videoBlurred]: !hasVideoPermission(obj?.id)
                            })}
                            key={idx}
                          >
                            <Link
                              onMouseEnter={(event) => mouseOverHandler(
                                event,
                                idx,
                                obj?.video_file,
                                obj?.thumbnails,
                                obj?.videoTitle,
                                obj?.SubCategory,
                                obj?.video_raw_file
                              )}
                              onMouseLeave={mouseLeaveHandler}
                              className={styles.imageGroupImageLink}
                              key={idx}
                              to={`${Pathname.getVideoPath(obj?.id)}${hideVideoTitles ? '?fromGift=true' : ''}`}
                              id="thumbnail-link"
                              onClick={(e) => {
                                if (isVideoLockedForUser(obj?.locked_for)) {
                                  e.preventDefault();
                                  return;
                                }
                                if (onVideoOpen) {
                                  e.preventDefault();
                                  onVideoOpen(obj?.id);
                                }
                              }}
                            >
                              {/* videoDetails is the tile's own item. It used
                                  to read resumeMe?.content[idx], but /profile
                                  never passes a `resumeMe` prop for this row,
                                  so it was always undefined — VideoAutoPlayer
                                  then fell back to `videoID` (the hover state,
                                  not an id) and opened the video with no id.
                                  That is the "Video Id is not specified" the
                                  API was returning. */}
                              <VideoAutoPlayer
                                dimensions={dimensions}
                                videoDetails={obj}
                                thumbNail={
                                  obj?.imagekit_icon
                                  || obj?.thumbnails
                                  || AlterImage
                                }
                                videoID={showAutoPlayDiv}
                                isLocked={isVideoLockedForUser(obj?.locked_for)}
                                onLockedClick={onShowPermissionModal}
                                onOpen={onVideoOpen}
                              />
                              <TitleLabel
                                title={obj?.title}
                                category={obj?.SubCategory}
                                hideTitle={hideVideoTitles}
                              />
                            </Link>
                            {isVideoLockedForUser(obj?.locked_for) && (
                              <div className={styles.lockIconOverlay}>
                                <LockIcon />
                              </div>
                            )}
                          </Box>
                        </div>
                      </SwiperSlide>
                    ))}
                  <div />
                  {' '}
                  {/* Carousel bug workaround */}
                </Swiper>
              </div>
              {type === 'photo_album'
                && Array.isArray(responseData)
                && responseData.length > 0 && (
                  <ImageGroupTitle title={`${profileDetails}'s Photo Albums`} />
                )}
              {type === 'photo_album'
                && Array.isArray(responseData)
                && responseData.length > 0 && (
                  <RowCarousel gap={5} className={styles.contentRow}>
                      {responseData?.map((obj, index) => (
                        <div
                        key={index}
                        className={styles.rowAlbumSlide}
                        onMouseEnter={(e) => onAlbumHover && onAlbumHover(obj, e.currentTarget)}
                        onMouseLeave={() => onAlbumLeave && onAlbumLeave()}
                        onClickCapture={(e) => {
                          // Intercept the inner <Link> in the capture phase so the
                          // album opens as an in-place modal instead of navigating
                          // to the old /album/:id page.
                          if (onAlbumOpen) {
                            e.preventDefault();
                            e.stopPropagation();
                            onAlbumOpen(obj?.id);
                          }
                        }}
                        >
                          <div className={styles.imageGroupImagesWrapper}>
                            <Box
                              className={cn(styles.hoverZoom, {
                                [styles.videoBlurred]: !hasAlbumPermission(obj?.id)
                              })}
                            >
                              <Link
                                className={cn({
                                  [styles.imageGroupImageLink]: true,
                                  [styles.albumTransition]: true,
                                })}
                                key={index}
                                to={Pathname.getAlbumPath(obj?.id)}
                              >
                                <div className={styles.imagePlaceholder}>
                                  {!loadedImages[obj.id] && (
                                    <div
                                      className={styles.ShimmerLoaderImage}
                                    />
                                  )}
                                  <Image
                                    src={obj?.icon}
                                    className={`${styles.imageGroupImage}`}
                                    onLoad={() => setLoadedImages((prev) => ({
                                      ...prev,
                                      [obj.id]: true,
                                    }))}
                                    onError={(e) => {
                                      e.target.src = AlterImage;
                                      setLoadedImages((prev) => ({
                                        ...prev,
                                        [obj.id]: true,
                                      }));
                                    }}
                                  />
                                </div>
                                <TitleLabel title={obj?.title} hideTitle={hideVideoTitles} />
                              </Link>
                              {/* LOCK UI DISABLED - Uncomment to restore:
                              {!hasAlbumPermission(obj?.id) && (
                                <div className={styles.lockIconOverlay}>
                                  <LockIcon />
                                </div>
                              )}
                              */}
                            </Box>
                          </div>
                        </div>
                      ))}
                  </RowCarousel>
                )}
              {/* playlist section */}
              {/* {type === 'playlists' && Array.isArray(responseData) && responseData.length > 0 && (
  <ImageGroupTitle title="Playlists" />
)} */}
              <div>
                {type === 'playlists'
                  && responseData?.map((obj, i) => (
                    <div key={i}>
                      {obj?.videos?.length > 0 && (
                        <ImageGroupTitle
                          /* iconType="playlist" */
                          title={obj?.playlist_title}
                          marginTitle={catG}
                          resumeWatching={resumeWatching}
                          setLoading={setLoading}
                          clearResumeWatching={clearResumeWatching}
                        />
                      )}

                      {obj?.videos?.length > 0 && (
                        <RowCarousel
                          gap={5}
                          className={styles.contentRow}
                          onReachEnd={() => {
                            const key = obj?.playlist_id;
                            if (obj?.videoPagination?.hasNextPage && !loadingMore.current[key]) {
                              loadingMore.current[key] = true;
                              setLoadingStates((prev) => ({ ...prev, [key]: true }));
                              setVideoOffset((prevOffsets) => {
                                const currentOffset = prevOffsets[key] ?? 0;
                                const newOffset = currentOffset + 10;
                                fetchData(0, key, newOffset).finally(() => {
                                  loadingMore.current[key] = false;
                                  setLoadingStates((prev) => ({ ...prev, [key]: false }));
                                });
                                return { ...prevOffsets, [key]: newOffset };
                              });
                            }
                          }}
                        >
                          {obj?.videos
                            ?.filter((video) => video && video.id)
                            ?.map((video, idx) => (
                              <div key={idx} className={cn(styles.rowVideoSlide, rowSlideExtra)}>
                                <div className={styles.imageGroupImagesWrapper}>
                                  <Box
                                    className={cn(styles.hoverZoom, {
                                      [styles.videoBlurred]: isVideoLockedForUser(video?.locked_for),
                                    })}
                                  >
                                    <Link
                                      onMouseEnter={(event) => mouseOverHandler(
                                        event,
                                        video?.id,
                                        video?.video_file,
                                        video?.thumbnails,
                                        video?.title,
                                        video?.SubCategory,
                                        video?.video_raw_file,
                                      )}
                                      onMouseLeave={mouseLeaveHandler}
                                      className={styles.imageGroupImageLink}
                                      to={`${Pathname.getVideoPath(video?.id)}${hideVideoTitles ? '?fromGift=true' : ''}`}
                                      state={{ from: 'playlist', playlist_id: obj?.playlist_id, playlistName: obj?.playlist_title }}
                                      id="thumbnail-link"
                                      onClick={(e) => {
                                        if (isVideoLockedForUser(video?.locked_for)) {
                                          e.preventDefault();
                                          return;
                                        }
                                        if (onVideoOpen) {
                                          e.preventDefault();
                                          onVideoOpen(video?.id, { from: 'playlist', playlist_id: obj?.playlist_id, playlistName: obj?.playlist_title });
                                        }
                                      }}
                                    >
                                      <VideoAutoPlayer
                                        dimensions={dimensions}
                                        videoDetails={video}
                                        thumbNail={(() => {
                                          try {
                                            if (Array.isArray(video?.thumbnails)) {
                                              return video?.thumbnails[0] || AlterImage;
                                            }
                                            const parsed = JSON.parse(video?.thumbnails);
                                            return parsed?.[0] ?? AlterImage;
                                          } catch (error) {
                                            return AlterImage;
                                          }
                                        })()}
                                        videoID={showAutoPlayDiv}
                                        isLocked={isVideoLockedForUser(video?.locked_for)}
                                        onLockedClick={onShowPermissionModal}
                                        onOpen={(vid) => onVideoOpen && onVideoOpen(vid, { from: 'playlist', playlist_id: obj?.playlist_id, playlistName: obj?.playlist_title })}
                                      />
                                      <TitleLabel
                                        title={video?.title}
                                        category={video?.SubCategory}
                                        hideTitle={hideVideoTitles}
                                      />
                                    </Link>
                                    {isVideoLockedForUser(video?.locked_for) && (
                                      <div className={styles.lockIconOverlay}>
                                        <LockIcon />
                                      </div>
                                    )}
                                  </Box>
                                </div>
                              </div>
                            ))}
                          {loadingStates[obj?.playlist_id] && (
                            <div className={styles.rowVideoSlide}>
                              <div className={styles.imageGroupImagesWrapper}>
                                <div className={styles.ShimmerLoader} />
                              </div>
                            </div>
                          )}
                        </RowCarousel>
                      )}
                    </div>
                  ))}
                {type === 'playlists' && pagination?.hasNextPage && (
                  <div className={styles.shimmerWrapper}>
                    {Array.from({ length: 4 }).map((_, index) => (
                      <div key={index} className={styles.ShimmerLoader} />
                    ))}
                  </div>
                )}
              </div>
              {/* {type === 'categories' && Array.isArray(responseData) && responseData.length > 0 && (
  <ImageGroupTitle title="Categories" />
)} */}
              <div>
                {type === 'categories'
                  && responseData?.map((obj, i) => (
                    <div key={i}>
                      {obj?.videos?.length > 0 && (
                        <ImageGroupTitle
                          /* iconType="category" */
                          title={obj?.category_name}
                          marginTitle={catG}
                          resumeWatching={resumeWatching}
                          setLoading={setLoading}
                          clearResumeWatching={clearResumeWatching}
                        />
                      )}

                      {obj?.videos?.length > 0 && (
                        <RowCarousel gap={5} className={styles.contentRow}>
                            {obj?.videos
                              ?.filter((video) => video && video.id)
                              ?.slice(0, 10)
                              ?.map((video, idx) => (
                                <div key={idx} className={cn(styles.rowVideoSlide, rowSlideExtra)}>
                                  <div
                                    className={styles.imageGroupImagesWrapper}
                                  >
                                    <Box
                                      className={cn(styles.hoverZoom, {
                                        [styles.videoBlurred]: isVideoLockedForUser(video?.locked_for)
                                      })}
                                    >
                                      <Link
                                        onMouseEnter={(event) => mouseOverHandler(
                                          event,
                                          video?.id,
                                          video?.video_file,
                                          video?.thumbnails,
                                          video?.title,
                                          video?.SubCategory,
                                          video?.video_raw_file
                                        )}
                                        onMouseLeave={mouseLeaveHandler}
                                        className={styles.imageGroupImageLink}
                                        to={`${Pathname.getVideoPath(video?.id)}${hideVideoTitles ? '?fromGift=true' : ''}`}
                                        state={{ from: 'category', category_id: obj?.category_id }}
                                        id="thumbnail-link"
                                        onClick={(e) => {
                                          if (isVideoLockedForUser(video?.locked_for)) {
                                            e.preventDefault();
                                            return;
                                          }
                                          if (onVideoOpen) {
                                            e.preventDefault();
                                            onVideoOpen(video?.id, { from: 'category', category_id: obj?.category_id });
                                          }
                                        }}
                                      >
                                        <VideoAutoPlayer
                                          dimensions={dimensions}
                                          videoDetails={video}
                                          thumbNail={(() => {
                                            try {
                                              if (
                                                Array.isArray(video?.thumbnails)
                                              ) {
                                                return (
                                                  video?.thumbnails[0]
                                                  || AlterImage
                                                );
                                              }
                                              const parsed = JSON.parse(
                                                video?.thumbnails
                                              );
                                              return parsed?.[0] ?? AlterImage;
                                            } catch (error) {
                                              return AlterImage;
                                            }
                                          })()}
                                          videoID={showAutoPlayDiv}
                                          isLocked={isVideoLockedForUser(video?.locked_for)}
                                          onLockedClick={onShowPermissionModal}
                                          onOpen={(vid) => onVideoOpen && onVideoOpen(vid, { from: 'category', category_id: obj?.category_id })}
                                        />
                                        <TitleLabel
                                          title={video?.title}
                                          category={video?.SubCategory}
                                          hideTitle={hideVideoTitles}
                                        />
                                      </Link>
                                      {isVideoLockedForUser(video?.locked_for) && (
                                        <div className={styles.lockIconOverlay}>
                                          <LockIcon />
                                        </div>
                                      )}
                                    </Box>
                                  </div>
                                </div>
                              ))}
                            {(obj?.videoPagination?.total ?? obj?.videos?.filter((video) => video && video.id)?.length ?? 0) > 10 && (
                              <div className={styles.rowVideoSlide}>
                                <div
                                  className={styles.imageGroupImagesWrapper}
                                  style={{
                                    display: 'flex',
                                    // flex-start, not center: the row is as tall
                                    // as a video tile INCLUDING its title, so
                                    // centring dropped this box below the line of
                                    // thumbnails it sits in.
                                    alignItems: 'flex-start',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    height: '100%',
                                  }}
                                  onClick={() => navigate(`/innerpage${hideVideoTitles ? '?fromGift=true' : ''}`, {
                                    state: {
                                      category_name: obj?.category_name,
                                      category_id: obj?.category_id,
                                      icon: obj?.icon,
                                      profile_id: profileID,
                                    },
                                  })}
                                >
                                  <div className={styles.showMoreBox}>
                                    <span className={styles.showMoreLabel}>
                                      Show More
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                        </RowCarousel>
                      )}
                    </div>
                  ))}
                {type === 'categories' && pagination?.hasNextPage && (
                  <div className={styles.shimmerWrapper}>
                    {Array.from({ length: 4 }).map((_, index) => (
                      <div key={index} className={styles.ShimmerLoader} />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ViewMyProjector;
